import processHEX from "./process-hex";
import processHSLA from "./process-hsla";
import processRGBA from "./process-rgba";

/**
 *
 * @param {String} input
 * @param {Number} [level]
 * @param {String} [name] Possible option name
 */
const checkColor = (input, level, name) => {
  const separator = level === 2 ? "▌" : "▏";

  switch (true) {
    case input.startsWith("#"):
      if (name === "target") {
        return input;
      } else {
        return processHEX(input, separator);
      }

    case input.startsWith("hsl"):
      return processHSLA(input, separator);

    case input.startsWith("rgb"):
      return processRGBA(input, separator);

    default:
      return input;
  }
};

export default checkColor;
